import React from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from "../style.module.scss"
import { FormattedMessage } from "react-intl";
import withSource from '../../../hocs/source-scoll'
import { getSensorsUrl } from "../../../utils/sensor";

const Tag = withSource(props =>{
    const { tag, innerRef, position } = props;

    const handleProductClick = event => {
		event.preventDefault()
        const { currentTarget } = event;

		const href = currentTarget?.href
		window.location.href = getSensorsUrl(href, {
			resourcepage_title: currentTarget.getAttribute("data-title"),
			resource_type: currentTarget.getAttribute("data-type"),
            resource_position: currentTarget.getAttribute("data-position"),
			resource_content: currentTarget.getAttribute("data-content"),
		})
	}

    return <a 
        onClick={handleProductClick}
        href={`/i/search/result?key=${encodeURIComponent(encodeURIComponent(tag.name))}`} 
        ref={innerRef}
        className={classes.Item}
        data-title={"product"}
        data-position={position}
        data-type="8"
        data-content={tag?.id}
    >{tag.name}</a>
})

const ProductRelatedSearcher = props =>{
    useStyles(classes);
    const {tags} = props;

    return (
        <React.Fragment>
            {
                tags && <div className={`${classes.ProductRelatedSearcher} ${classes.GolbalBorderTop}`}>
                    <div className={classes.Hd}>
                        <FormattedMessage id="related_searches" defaultMessage="Related Searches" />
                    </div>

                    <div className={classes.Bd}>
                        {
                            tags?.map((tag,index) =><Tag tag={tag} key={index} position={index+1} />)
                        }
                    </div>
                </div>
            }
            
        </React.Fragment>
    )
}

export default ProductRelatedSearcher;